module.exports = __webpack_public_path__ + "img/ZB52_03.a20c9dbd.jpg";